import Heading from './../components/Heading';
import SmallHeading from './../components/SmallHeading';
import DetailsHeading from './../components/DetailsHeading';
import TestimonialCard from './../components/TestimonialCard';

function TestimonialsSection() {
  return (
    <section className='bg-emerald-500 bg-opacity-10 shadow-md pb-10'>
    <SmallHeading name="Client Testimonials" tstyle="text-center my-1 mt-10 pt-10"/>
    <Heading name="Supporting Your Goals Every Step of the Way" tstyle="text-center my-1"/>
    <div className='mt-4 px-10' >
      <DetailsHeading 
      name="What Our Clients Say" 
      tstyle="my-1"
      />

    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 mx-10">
      <TestimonialCard 
        client="Matthew Shelley"
        clientTitle="CEO of Top Class Tuition"
        description="PocketLPO has been instrumental in managing our legal needs efficiently. Their remote counsel service is both convenient and highly professional."/>
      <TestimonialCard 
        client="Nadeem Azam"
        clientTitle="CFO of Pursue Today"
        description="Their expertise in compliance helped us navigate complex regulations effortlessly. Highly recommend their services!"/>
        <TestimonialCard 
        client="Roba Bashir"
        // clientTitle="CFO of Global Ventures LLC"
        description="PocketLPO has been a game-changer for our legal operations. Their team consistently delivers precise, well-negotiated contracts and policies that protect our interests while maintaining commercial sensibility. They are responsive, sharp, and deeply reliable."/>  
    </div>
    </section>
  );
}

export default TestimonialsSection;
